var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg","focusable":"false","role":"img"}},[_c('path',{attrs:{"d":"m6 3-6 8h4v10h4v-10h4zm16 14h-8v-2h8zm2 2h-10v2h10zm-4-8h-6v2h6zm-2-4h-4v2h4zm-2-4h-2v2h2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }